import { useState } from "react";
import { useTableProvider } from "../../providers";

import { Group } from "@mantine/core";
import { TableComponent } from "components";

export function TableHeadComponent() {
  const [sn, setSn] = useState<string>("");
  const { setFilter } = useTableProvider();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSn(e.target.value);
  }

  function handleClick() {
    setFilter({ serialNumber: sn });
  }

  return (
    <Group position="apart">
      <Group>
        <TableComponent.TableInput.SearchInput
          value={sn}
          onChange={handleChange}
          placeholder="Search by SN"
        />
        <TableComponent.TableInput.Button onClick={handleClick} color="gray">
          Search
        </TableComponent.TableInput.Button>
      </Group>
    </Group>
  );
}
